module.exports = __webpack_public_path__ + "media/icon-arrow-left.b2fdcb7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/shared/assets/icon-arrow-left.svg
// module id = ./src/templates/shared/assets/icon-arrow-left.svg
// module chunks = 0